export default /* css */ `
@font-face {
	font-display: swap;
	font-family: futura-pt-condensed;
	src:
		url(https://use.typekit.net/af/3b8138/00000000000000000001203f/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3) format('woff2'),
		url(https://use.typekit.net/af/3b8138/00000000000000000001203f/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3) format('woff'),
		url(https://use.typekit.net/af/3b8138/00000000000000000001203f/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3) format('opentype');
	font-style: normal;
	font-weight: 800;
}

:host {
	--oc-font-family: 'Public Sans', sans-serif;
  
	--oc-bg-grey-light: #eaeae9;
	--oc-border: #e5e5e5;
	--oc-box-shadow: #dcdcdc;
	--oc-line-secondary: #f2f2f2;
	--oc-primary-blue: #033954;
	--oc-primary-white: #fff;
	--oc-text-body: #20242e;
	--oc-text-subtext: #9d9da3;

	--ogm-grizzlies: #9dafbd;
	--ogm-pelicans: #052643;
	--ogm-seahawks-disabled: #1ed56090;
	--ogm-seahawks: #1ed560;
	--ogm-timberwolves: #00182e;
	--ogm-white: #fff;
}`;
